import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import Orders from "./Orders";
import ReadyToShipOrders from "./ReadyToShipOrders";
import InTransitOrders from "./InTransitOrders";
import DeliveredOrders from "./DeliveredOrders";
import CancelledOrder from "./CancelledOrder";
import AllOrder from "./AllOrder";
import { FaUpload, FaBars } from "react-icons/fa";
import axios from "axios";
import { ChevronDown } from "lucide-react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import BulkUploadPopup from "./BulkUploadPopup";
import Cookies from "js-cookie";



import RTO from "./RTO"
import OutForDelivery from "./OutForDelivery";
import RTOIntransit from "./RTOIntransit";
import RTODelivered from "./RTODelivered";
import RTOLost from "./RTOLost";
import RTODamaged from "./RTODamaged";
import Lost from "./Lost";
import Damaged from "./Damaged";
const OrdersPage = () => {

  const desktopDropdownRef = useRef(null);
  // console.log("ewwew",activeTab)
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [upload, setUpload] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [orders, setOrders] = useState([]);
  const [showMoreTabs, setShowMoreTabs] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const mobileDropdownRef = useRef(null);
  const location = useLocation()

  // const dropdownRef = useRef(null);
  const { id } = useParams();

  const tabs = [
    "New",
    "Ready to Ship",
    "In Transit",
    "Out for Delivery",
    "Delivered",

  ];
  const isNdrRoute =
    location.pathname === "/dashboard/ndr" ||
    location.pathname.startsWith("/dashboard/Setup&Manage/User/Profile/") && location.pathname.includes("/ndr");

  const tabStorageKey = isNdrRoute ? "activeNdrTab" : "activeOrderTab";

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem(tabStorageKey) || "New";
  });

  useEffect(() => {
    localStorage.setItem(tabStorageKey, activeTab);
  }, [activeTab, tabStorageKey]);


  const moreTabs = ["Cancelled", "Lost", "Damaged", "RTO Initiated", "RTO In Transit", "RTO Delivered", "RTO Lost", "RTO Damaged", "All"];
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = Cookies.get("session");

        const response = await axios.get(
          `${REACT_APP_BACKEND_URL}/order/orders`,
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("This is OrdersPage", response);
        setOrders(response.data.orders);
        setRefresh(false);
        const courierNames = [
          ...new Set(response.data.map((order) => order.courierServiceName)),
        ];


        // console.log(orders)
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, [refresh]);

  const handleNewOrderClick = async () => {
    try {

      const token = Cookies.get("session");

      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/users/getUsers`,
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );

      if (response.data.isSeller) {
        navigate("/dashboard/order/neworder");
      } else {
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching sellers:", error);
    }
  };



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".mobile-dropdown")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const renderTabContent = () => {
    switch (activeTab) {
      case "New":
        return <Orders />;
      case "Ready to Ship":
        return <ReadyToShipOrders />;
      case "In Transit":
        return <InTransitOrders />;
      case "Out for Delivery":
        return <OutForDelivery />;
      case "Delivered":
        return <DeliveredOrders />;
      case "Cancelled":
        return <CancelledOrder />;
      case "RTO Initiated":
        return <RTO />;
      case "RTO In Transit":
        return <RTOIntransit />;
      case "RTO Delivered":
        return <RTODelivered />;
      case "RTO Lost":
        return <RTOLost />;
      case "RTO Damaged":
        return <RTODamaged />;
      case "Lost":
        return <Lost />;
      case "Damaged":
        return <Damaged />;
      case "All":
        return <AllOrder />;
      default:
        return <div>Select a tab to view orders.</div>;
    }
  };



  useEffect(() => {
    function handleClickOutside(event) {
      if (
        desktopDropdownRef.current &&
        !desktopDropdownRef.current.contains(event.target)
      ) {
        setShowMoreTabs(false);
      }

      if (
        mobileDropdownRef.current &&
        !mobileDropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowMoreTabs(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleBulkUpload = async () => {

    try {

      const token = Cookies.get("session");

      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/users/getUsers`,
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );

      if (response.data.isSeller) {
        setUpload(true);
      } else {
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching sellers:", error);
    }
  };
  return (
    <div className={`md:px-2 px-1 ${showModal ? "overflow-hidden" : ""}`}>
      {!id && (
        <div className="">
          <h1 className="text-[12px] md:text-[18px] font-[600] text-gray-700">Orders</h1>
        </div>
      )}

      {/* Tabs for larger screens */}
      <div className="flex flex-row justify-between items-center gap-4 mt-2">
        <div className="hidden md:flex flex-wrap gap-2 relative">
          {/* Only show visible tabs, not the 'more' ones */}
          {tabs.filter(tab => !moreTabs.includes(tab)).map((tab) => (
            <button
              key={tab}
              className={`px-3 py-2 text-gray-700 text-[12px] rounded-lg font-[600] transition-all duration-200 ${activeTab === tab
                ? "bg-[#632C9D] text-white"
                : "bg-white text-gray-700 hover:bg-purple-200"
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}

          {/* More Dropdown */}
          <div className="relative" ref={desktopDropdownRef}>
            <button
              onClick={() => setShowMoreTabs((prev) => !prev)}
              className={`px-3 py-2 text-gray-700 text-[12px] rounded-lg font-[600] transition-all duration-200 flex items-center gap-1 ${moreTabs.includes(activeTab)
                ? "bg-[#632C9D] text-white"
                : "bg-white text-gray-700 hover:bg-purple-200"
                }`}
            >
              {moreTabs.includes(activeTab) ? activeTab : "More"}
              <ChevronDown className="w-4 h-4" />
            </button>

            {showMoreTabs && (
              <div className="absolute left-0 top-full mt-1 bg-white border border-green-200 rounded-md shadow-md z-50 w-40">
                {moreTabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => {
                      setActiveTab(tab);
                      setShowMoreTabs(false);
                    }}
                    className={`w-full text-left px-3 text-gray-700 py-2 text-[12px] font-[600] transition hover:bg-purple-100 ${activeTab === tab
                      ? "bg-gray-200 font-[600] text-gray-700"
                      : ""
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* New Order + Filters */}
        <div className="flex items-center gap-2">
          <div
            className="hidden sm:flex flex-col items-center space-y-2"
            onClick={handleBulkUpload}
          >
            <label className="cursor-pointer flex items-center gap-2 text-white bg-[#632C9D] px-3 h-[34px] rounded-lg border-2 border-[#632C9D] transition text-[10px] sm:text-[12px] font-[600]">
              <FaUpload className="text-white bg-[#632C9D]" />
              <span className="hidden sm:inline">Upload</span>
            </label>
          </div>
          <div className="hidden md:flex md:w-auto w-full">
            <button
              onClick={handleNewOrderClick}
              className="px-3 py-2 bg-[#632C9D] text-white rounded-lg text-[12px] font-[600]"
            >
              + New Order
            </button>
          </div>

        </div>
      </div>



      {/* Mobile Dropdown for Tabs */}

      <div className="sm:hidden flex gap-2 w-full relative mb-2" ref={mobileDropdownRef}>
        {/* Dropdown Button Wrapper */}
        <div className="w-4/5">
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="w-full flex font-[600] justify-between items-center px-3 h-[30px] border border-gray-300 rounded-lg bg-[#632C9D] text-[10px] text-white"
          >
            {activeTab}
            <ChevronDown className="w-3 h-3 ml-2" />
          </button>

          {dropdownOpen && (
            <div className="absolute left-0 top-full mt-1 w-3/5 bg-white border rounded shadow-md z-[100] max-h-60 overflow-y-auto">
              {/* Main tabs */}
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`w-full flex text-left px-3 py-2 h-[30px] font-[600] text-[10px] ${activeTab === tab ? "bg-purple-100" : "hover:bg-purple-50"
                    }`}
                  onClick={() => {
                    setActiveTab(tab);
                    setDropdownOpen(false);
                  }}
                >
                  {tab}
                </button>
              ))}

              {/* Divider */}
              <div className="border-t border-gray-200 my-1" />

              {/* More tabs */}
              {moreTabs.map((tab) => (
                <button
                  key={tab}
                  className={`w-full font-[600] text-left px-3 py-2 text-[10px] ${activeTab === tab ? "bg-purple-100 font-[600]" : "hover:bg-purple-50"
                    }`}
                  onClick={() => {
                    setActiveTab(tab);
                    setDropdownOpen(false);
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* New Order Button Wrapper */}
        <div className="w-1/2">
          <button
            onClick={handleNewOrderClick}
            className="w-full px-3 h-[30px] bg-[#632C9D] text-white rounded-lg text-[10px] font-[600]"
          >
            + New Order
          </button>
        </div>
        <div
          className="flex flex-col items-center space-y-2"
          onClick={handleBulkUpload}
        >
          <label className="cursor-pointer flex items-center gap-2 text-white bg-[#632C9D] px-3 py-2 rounded-lg border-2 border-[#632C9D] transition text-[10px] sm:text-[12px] font-[600]">
            <FaUpload className="text-white bg-[#632C9D]" />
            <span className="hidden sm:inline">Upload</span>
          </label>
        </div>
      </div>




      {/* Search and Actions */}


      {/* Modal for KYC Incomplete */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-[70] p-2">
          {/* Background overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

          {/* Modal Content */}
          <div className="relative bg-white rounded-lg p-6 max-w-md w-full shadow-lg">
            <p className="text-lg font-medium mb-4 text-center">
              Your KYC is incomplete, please complete your KYC to create a new
              order.
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="px-6 py-2 bg-[#632C9D] text-white rounded-lg text-sm md:text-base"
                onClick={() => {
                  navigate("/kyc");
                  setShowModal(false);
                }}
              >
                OK
              </button>
              <button
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg text-sm md:text-base"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tab Content */}
      <div className="overflow-x-auto">{renderTabContent()}</div>
      {upload && (
        <BulkUploadPopup
          onClose={() => setUpload(false)}
          setRefresh={setRefresh}

        />
      )}
    </div>
  );
};

export default OrdersPage;